export function appFormDataTestFactory(name = 'element') {
  const prefix = `app-form-${name}`;
  return {
    get control() {
      return `${prefix}-control`;
    },
    get label() {
      return `${prefix}-label`;
    },
    get input() {
      return `${prefix}-input`;
    },
    get formHelper() {
      return `${prefix}-form-helper`;
    },
    get formHelperError() {
      return `${prefix}-form-helper-error`;
    }
  };
}
